module.exports = __webpack_public_path__ + "img/directory--avatar.431761da.svg";